import { useQuery } from "@tanstack/react-query";

import { subscriptionApi, subscriptionQueryKeys } from "../api/subscription";

import { planLabel } from "./planLabel";

/**
 * Nhãn gói của phòng khám đang đăng nhập, dùng chung cho mọi màn (#19596).
 *
 * <p>Dùng ĐÚNG `queryKey` mà `/settings/subscription` dùng, nên hai nơi chia sẻ một bản cache và
 * không thể hiện hai gói khác nhau cùng lúc — đó là nửa còn lại của việc "thống nhất nhãn gói":
 * một nguồn dữ liệu, không chỉ một hàm định dạng.
 *
 * <p>Lỗi mạng không làm vỏ ứng dụng vỡ: `data` vắng → {@link planLabel} trả `null` → không hiện
 * gì. Đó là hành vi chủ sản phẩm chốt ("chưa tải được gói thì không mặc định hiển thị Lite").
 */
export function useCurrentPlanLabel(): string | null {
  const q = useQuery({
    queryKey: subscriptionQueryKeys.summary(),
    queryFn: () => subscriptionApi.summary(),
    staleTime: 5 * 60_000,
    retry: false,
  });
  return planLabel(q.data?.current, q.isLoading);
}
